import home1 from "../../assets/img/IMG-20251110-WA0039.jpg";
import { Link } from "react-router-dom";
import { FiChevronRight } from "react-icons/fi";
const ourService = [
  { id: 1, name: "Landscape Design", url: "landscape-design" },
  { id: 2, name: "Hardscape", url: "hardscape" },
  { id: 3, name: "Landscape Lighting", url: "landscape-lighting" },
  { id: 4, name: "Softscape", url: "softscape" },
  { id: 5, name: "Plantation", url: "plantation" },
  { id: 6, name: "Replanting", url: "replanting" },
  {
    id: 7,
    name: "Lawn Development and Maintenance",
    url: "lawn-development-and-maintenance",
  },
  {
    id: 8,
    name: "Horticultural Maintenance",
    url: "horticultural-maintenance",
  },
  {
    id: 9,
    name: "Vertical & Terrace Garden",
    url: "vertical-and-terrace-garden",
  },
  { id: 10, name: "Irrigation System", url: "irrigation-system" },
];
function Horticultural() {
  return (
    <>
      <section className="serviceList sectionPD">
        <div className="container">
          <div className="row">
            <div className="col-lg-4 col-md-12">
              <div className="aboutImg">
                <img src={home1} alt="About" className="img-fluid" />
              </div>
              <div className="blogCategory mt-4">
                <ul>
                  {ourService.map((item) => {
                    return (
                      <li key={item.id}>
                        <Link to={`${item.url}`}>
                          <FiChevronRight />
                          {item.name}
                        </Link>
                      </li>
                    );
                  })}
                </ul>
              </div>
            </div>
            <div className="col-lg-8 col-md-12">
              <div className="aboutWooden">
                <div className="fisherman-content">
                  <h3>🌿 About Horticulture</h3>
                  <p>
                    A lawn is often the first thing people notice about a garden
                    or outdoor space. It’s not just grass; it’s the foundation
                    of a landscape, a soft green carpet that sets the tone for
                    everything around it. Developing and maintaining a healthy
                    lawn requires patience, knowledge, and consistent care.
                  </p>
                  <p>
                    Lawn development begins with the right preparation —
                    selecting suitable grass types for the climate, preparing
                    soil, and ensuring proper drainage. A well-planned lawn
                    provides a resilient base that can handle daily use,
                    seasonal changes, and natural growth.
                  </p>
                  <p>
                    Maintenance is just as important as development. Regular
                    mowing, watering, fertilizing, and aerating keep the lawn
                    healthy and vibrant. Proper maintenance prevents weeds,
                    encourages thick growth, and ensures the lawn stays soft,
                    lush, and inviting year-round.
                  </p>
                  <p>
                    Authentic lawn care is about understanding nature, not
                    fighting it. Every lawn has its rhythm — the way it responds
                    to sunlight, rainfall, and seasonal variations. Paying
                    attention to these details makes a real difference, creating
                    a green space that feels alive, welcoming, and sustainable.
                  </p>
                  <p>
                    A well-developed and well-maintained lawn doesn’t just
                    beautify a space; it becomes a place to gather, relax, and
                    enjoy nature. It’s the heart of an outdoor area, bringing
                    harmony, comfort, and life to the surroundings.
                  </p>
                </div>

                <div className="fisherman-content">
                  <h5>🛠️ Essential Horticultural Practices</h5>
                  <ul>
                    <li>🌱 Soil testing and preparation</li>
                    <li>🌿 Plant propagation (seed, grafting, layering)</li>
                    <li>💧 Efficient irrigation and water management</li>
                    <li>🧪 Nutrient and fertilizer management</li>
                    <li>
                      🦟 Pest and disease control using eco-friendly methods
                    </li>
                    <li>✂️ Pruning and training for shape and productivity</li>
                    <li>🏡 Sustainable garden design and planning</li>
                  </ul>
                </div>
                <div className="fisherman-content">
                  <h5>🌿 Want to Cultivate Something Beautiful?</h5>
                  <p>
                    Whether you're growing your own food or designing a relaxing
                    outdoor retreat, our horticultural experts can help you
                    plan, plant, and maintain a thriving green space that
                    reflects your needs and vision.
                  </p>
                  <a
                    className="commonButton mt-3"
                    href="mailto:info@example.com"
                  >
                    📧 Contact Us Today
                  </a>
                </div>
              </div>
            </div>
            <div className="col-lg-12 mt-5">
              {/* Horticulture Services */}
              <div className="fisherman-content d-none">
                <h4>🌱 Lawn Development (Establishment Phase)</h4>
                <h5>🌸 Branches of Horticulture</h5>
                <ul>
                  <li>
                    🍎 <strong>Pomology</strong> – Cultivation of fruit crops
                  </li>
                  <li>
                    🥬 <strong>Olericulture</strong> – Vegetable growing and
                    management
                  </li>
                  <li>
                    🌼 <strong>Floriculture</strong> – Production of flowers and
                    ornamental plants
                  </li>
                  <li>
                    🌲 <strong>Arboriculture</strong> – Care and management of
                    trees
                  </li>
                  <li>
                    🏡 <strong>Landscape Horticulture</strong> – Designing and
                    maintaining aesthetically pleasing spaces
                  </li>
                  <li>
                    🧪 <strong>Post-Harvest Technology</strong> – Handling,
                    storage, and processing of horticultural products
                  </li>
                </ul>
              </div>
              <div className="fisherman-content d-none">
                <h5>🌾 Our Horticulture Services Include:</h5>
                <ul>
                  <li>Garden and orchard design</li>
                  <li>Soil analysis and plant nutrition planning</li>
                  <li>Tree planting and care</li>
                  <li>Seasonal flower and vegetable bed setup</li>
                  <li>Indoor and vertical garden installations</li>
                  <li>Irrigation system setup and maintenance</li>
                  <li>Consultation on sustainable gardening</li>
                </ul>
              </div>
              {/* Call to Action */}
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Horticultural;
